import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'

import { NetworkIcon } from '@root/entities/network/ui'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { AmountFormatted } from '@root/shared/core/format'

import { TradingPairExploreItemMetricsItem } from './pair-explore-item-metrics-item'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const TradingPairExploreItemMetricsFees = memo(
  ({ pair, className }: Props) => {
    const [totalFees] = useAtom(pair.fees.totalFees)

    return (
      <TradingPairExploreItemMetricsItem className={className}>
        <TradingPairExploreItemMetricsItem.Label>
          F:
        </TradingPairExploreItemMetricsItem.Label>
        <FlashTextContentDistinct>
          <AmountFormatted amount={totalFees} />
        </FlashTextContentDistinct>
        <NetworkIcon size={12} network={pair.network} />
      </TradingPairExploreItemMetricsItem>
    )
  },
)
